export enum ApiErrorCodes {
    INVALID_CLIENT_MESSAGE = 'INVALID_CLIENT_MESSAGE',
    INVALID_CREDENTIALS_MESSAGE = 'INVALID_CREDENTIALS_MESSAGE',
    USER_DOES_NOT_HAVE_BACK_ACCESS = 'USER_DOES_NOT_HAVE_BACK_ACCESS',
}
